import { useSyncExternalStore } from "react";

import { useIsMobile } from "./useIsMobile";

type IsEmbeddedProps = {
  isEmbedded: boolean;
  isMobile: boolean;
  height: string;
};

// Fixed for the life of the document, so nothing to subscribe to. Read
// synchronously so the first client render already has the real value.
const subscribe = () => () => {};
const getSnapshot = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true; // cross-origin parent throws — that is an iframe
  }
};
// The server renders for the iframe; otherwise the standalone header lands in
// the HTML and is removed on the client, a flash on every load.
const getServerSnapshot = (): boolean => true;

export function useIsEmbedded(): IsEmbeddedProps {
  const isEmbedded = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );
  const isMobile = useIsMobile();

  let height;

  if (isMobile && isEmbedded) {
    height = "50dvh";
  } else if (isMobile && !isEmbedded) {
    height = "calc(50dvh - var(--layout-headerHeightMobileHalf))";
  } else if (!isMobile && !isEmbedded) {
    height = "100%";
  } else {
    height = "100dvh";
  }

  return {
    isEmbedded,
    isMobile,
    height,
  };
}
